
function getName(value) {
  if (/^sms whatsapp:\+/i.test(value)) {
    value = value.replace(/sms whatsapp:/i, '');
  }
  return value;
}

/**
 *
 * @param {string} key
 * @param {object} data
 *
 * @return object
 */
function buildChatItem(key, data) {
  return {
    key: key,
    type: 'chat',
    activeItem: false,
    unsubscribe: null,
    active: ('active' in data && data) ? data.active : false,
    title: ('name' in data) ? `${getName(data.name)} - ${data.dep_name}` : `Unknow`,
    date: !data.created_chat_engine ? new Date(data.startedAt * 1000) : new Date(data.startedAt),
    data: {
      roomId: key,
      unreadMessages: data.unreadMessagesCount || 0,
      from: ('from' in data) ? data.from : 'lhc',
      status: (data.status) ? data.status : 'active',
      chatId: data.id,
      tags: data.chatDispositions ?? [],
      chatDispositions: data.chatDispositions ?? [],
      waitingForClientAnswer: data.waitingForClientAnswer ?? null,
      dept_id: data.dep_id,
      waitingForAgentAnswer: data.waitingForAgentAnswer ?? false,
      lastMessage: data.lastMessage,
      wasTransfered: false,
    },
    clientinfo: (data.clientInfo) ? data.clientInfo : [],
    integrations : data.integrations || null,
    createdWitChatEngine: data.created_chat_engine ?? false,
    version : data.version
  }
}

const state = {
  chatCenterRef: null,
}

const mutations = {
  SET_CHAT_CENTER_REF: (state, ref) => state.chatCenterRef = ref,
}

const actions = {
  listenNewAgentsChats({ rootGetters, dispatch, commit, state }) {
    const agent = rootGetters.getAgent
    const user = rootGetters.getUser;
    const firebase = rootGetters.getFirebase;

    if (state.chatCenterRef) {
      return
    }

    const date = new Date();
    date.setMinutes(date.getMinutes() - agent.agentActivityTimeout);

    const ref = firebase.database().ref(`chat_center/${user.uid}`).orderByChild('startedAt').startAt(date.getTime())

    commit('SET_CHAT_CENTER_REF' , ref)

    ref.on('child_added', async (snap) => {
      const chatItem = buildChatItem(snap.key, snap.val());
      const chat = { name: snap.val().name, path: rootGetters.getChatPath, roomId: chatItem.key, myself: { id: agent.chat_center_id }, version: chatItem.version };
      dispatch('_chats/initChatroom', chat, { root: true })

      commit('ADD_ACTIVITY', chatItem, { root: true });
       
      // Tells to the chat engine that the chat was accepted by the agent correctly
      if (rootGetters.getLogged && rootGetters.getLoggedInChatCenter && chatItem.active) {
         snap.ref.update({ isChatAttended: true })
      }

      if (rootGetters.getPendingChatAccept) {
        const { id: pendingRoomId = null } = rootGetters.getPendingChatAccept 
        if (pendingRoomId === chatItem.key) {
          dispatch('setPendingChatAsActiveChat', pendingRoomId);
          dispatch('_chats/fetchAndListenAllMessagesFromChat', { roomId: pendingRoomId }, { root: true })
        }
      }
    });

    ref.on('child_changed', (snap) => {
      const chatItem = buildChatItem(snap.key, snap.val());
      if (!chatItem.active) {
        const chat = rootGetters['_chats/getChatByRoomId'](snap.key) 

        if (chat.unsubscribe) {
          chat.unsubscribe()
        }

        if (chat.internalNotesUnsubscribe) {
          chat.internalNotesUnsubscribe()
        }

        dispatch('_chats/stopListenMessagesFromChatroom', { roomId: snap.key}, { root: true })
      }

      if (rootGetters['getActivityByKey'](snap.key)) {
        commit('UPDATE_ACTIVITY', chatItem, { root: true });
      } else {
        commit('ADD_ACTIVITY', chatItem, { root: true });
      }

    });
    

    ref.on('child_removed', (snap) => {
      const roomId = snap.key

      const chat = rootGetters['_chats/getChatByRoomId'](snap.key) 

      if (chat.unsubscribe) {
        chat.unsubscribe()
      }

      if (chat.internalNotesUnsubscribe) {
        chat.internalNotesUnsubscribe()
      }

      commit('REMOVE_ACTIVITY', roomId, { root: true });
      commit('_chats/REMOVE_CHAT', roomId, { root: true })
      dispatch('_chats/stopListenMessagesStatus', roomId, { root: true})
    });
  },
  createAction({ rootGetters }, action ) {
    const user = rootGetters.getUser;
    const firebase = rootGetters.getFirebase;
    return firebase.database().ref(`chat_engine_actions`).push({...action, uid: user.uid, host: process.env.VUE_APP_CHAT_ENGINE_HOST })
  },
  listenToChatEngineAction({ rootGetters }, { key, callback }) {
    const firebase = rootGetters.getFirebase;
    firebase.database().ref(`chat_engine_actions`).child(key).on('value', (snap) => {
      if (snap) {
        callback(snap.val());
      }
    })
  },
  removeAction({ rootGetters }, actionKey ) {
    const firebase = rootGetters.getFirebase;
    return firebase.database().ref(`chat_engine_actions`).child(actionKey).remove();
  },
  setChatDispositions( { rootGetters }, { roomId, chatDispositions }) {
    const user = rootGetters.getUser;
    const firebase = rootGetters.getFirebase;
    const organizationId = rootGetters.getAgent.organization_id;
    return firebase.firestore().doc(`livehelperchat/${organizationId}/chats/${roomId}`).update({ chatDispositions }).then(() => {
      firebase.database().ref('chat_center').child(user.uid).child(roomId).update({ chatDispositions })
    })
  },
  setChatClassification({ rootGetters} , { roomId, chatClassifications }) {
    const firebase = rootGetters.getFirebase
    const organizationId = rootGetters.getAgent.organization_id
    return firebase.firestore().doc(`livehelperchat/${organizationId}/chats/${roomId}`).update({ chatClassifications })
  },
  setPendingChatAsActiveChat({ commit, rootGetters }, key) {
    commit('SET_PENDING_CHAT_ACCEPT', false, { root : true });
    commit('FORCE_ACTIVE_ITEM', key, {root : true});
    if (rootGetters.getShowAcceptChatWindow) {
      commit('SET_SHOW_ACCEPT_PENDING_CHAT', false, { root: true });
    }
  },
  updateValues({ rootGetters }, roomId) {
    const user = rootGetters.getUser;
    const firebase = rootGetters.getFirebase
    const organizationId = rootGetters.getAgent.organization_id
    firebase.firestore().doc(`livehelperchat/${organizationId}/chats/${roomId}`).get().then((doc) => {
      if (!doc.exists) {
        return
      }

      const { chatDispositions = [], dep_id = null, dep_name = '' } = doc.data()
      firebase.database().ref(`chat_center/${user.uid}`).child(roomId).update({
        chatDispositions
      })

      if (dep_id) {
        firebase.database().ref(`chat_center/${user.uid}`).child(roomId).update({
          dep_id,
          dep_name
        })
      }

    })
  },
  async fetchChat({ rootGetters} , { roomId, organizationId }) {
        const firebase = rootGetters.getFirebase
        const snapshot = await firebase.firestore().collection('livehelperchat').doc(organizationId + "").collection('chats').doc(roomId).get()
        return snapshot.exists ? snapshot.data() : null
    }
}

export default {
  actions,
  mutations,
  state,
  namespaced: true,
}